"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ImageGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="imagegallery" ref={ref} className={cn("w-full bg-background transition-opacity duration-1000 ease-out", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="w-full">
        <div className="w-full bg-cover bg-center !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/11livraison-cle-main.png)] !h-[650px]" />
      </div>
    </section>;
}